export default {
  cardholder_name: 'Koko nimi',
  cardholder_name_placeholder: 'Nimi kortissa',
  card_number: 'Kortin numero',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Voimassaolopäivä',
  expiry_placeholder: 'KK / VV',
  cvv: 'Turvakoodi',
  cvv_label: 'Turvakoodi (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Alustetaan turvallista korttilomaketta…',
  sdk_load_failed: 'Turvallista korttilomaketta ei voitu ladata. Tarkista yhteytesi ja päivitä sivu.',
  errors: {
    number_blank: 'Syötä kortin numero.',
    number_invalid: 'Kortin numero ei kelpaa. Tarkista numerot ja yritä uudelleen.',
    number_incomplete: 'Kortin numero on vaillinainen.',
    cvv_blank: 'Syötä kortin kääntöpuolella oleva turvakoodi.',
    cvv_invalid: 'Turvakoodi ei kelpaa. Tarkista kortin 3 tai 4 numeroa.',
    cvv_incomplete: 'Syötä kaikki turvakoodin {{count}} numeroa.',
    expiry_invalid: 'Syötä voimassaolopäivä muodossa KK / VV.',
    expired: 'Kortti on vanhentunut. Käytä toista korttia.',
    name_blank: 'Syötä nimi täsmälleen samalla tavalla kuin se on kortissa.',
    configuration: 'Korttimaksut eivät ole juuri nyt käytettävissä. Valitse toinen maksutapa.',
    generic: 'Korttitietojasi ei voitu tarkistaa. Yritä uudelleen.',
  },
};
